// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__ytnLi","return-link":"navigation_return-link__mYRpl","support-link":"navigation_support-link__DA2Lx"};